import { string, mixed, object, number } from 'yup';

import { BetCoefficientTypesEnum, YUP_ERRORS_MESSAGES } from '@shared/constants';

export const betOutcomeFormValidationSchema = object().shape({
  name: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  description: string().trim().required(YUP_ERRORS_MESSAGES.REQUIRED),
  coefficientType: mixed().oneOf(Object.values(BetCoefficientTypesEnum)).required(YUP_ERRORS_MESSAGES.REQUIRED),
  coefficientValue: number().when('coefficientType', ([coefficientType], coefficientValueSchema) => {
    if (coefficientType === BetCoefficientTypesEnum.MANUAL) {
      return coefficientValueSchema.required(YUP_ERRORS_MESSAGES.REQUIRED);
    } else {
      return coefficientValueSchema.nullable();
    }
  }),
  maxBet: number().min(1).required(YUP_ERRORS_MESSAGES.REQUIRED),
});
